/* Shared, country-aware phone formatting (extracted from Profile.js so the
   Resume page formats phone numbers identically). US → +1 (xxx) xxx-xxxx;
   everything else → +<callingCode> <grouped digits>, so international numbers
   (e.g. India +91) are formatted, not mangled/truncated to a US shape. */
import topCountries from "../jsx/components/Dashboard/Profile/topCountries";

export function formatUSPhoneNumber(value) {
  let cleaned = String(value || "").trim();
  if (cleaned.startsWith("+1")) cleaned = cleaned.slice(2).trim();
  const x = cleaned.replace(/[^\d]/g, "").substring(0, 10);
  if (!x) return "";
  if (x.length < 4) return "(" + x;
  if (x.length < 7) return `(${x.slice(0, 3)}) ${x.slice(3)}`;
  return `+1 (${x.slice(0, 3)}) ${x.slice(3, 6)}-${x.slice(6)}`;
}

export function formatInternationalPhoneNumber(value, countryCode) {
  const cc = String(countryCode || "").replace(/[^\d]/g, "");
  let digits = String(value || "").replace(/[^\d]/g, "");
  if (cc && digits.startsWith(cc)) digits = digits.slice(cc.length);
  digits = cc === "91" ? digits.substring(0, 10) : digits.substring(0, 15);
  if (!cc && !digits) return "";
  if (!digits) return `+${cc}`;
  let grouped = digits;
  if (cc === "91" && digits.length > 5) grouped = `${digits.slice(0, 5)} ${digits.slice(5)}`;
  return `+${cc} ${grouped}`.trim();
}

export function formatPhoneByCountry(value, country, countryCode) {
  const ccRaw = String(countryCode || "").trim();
  const cc = ccRaw.replace(/[^\d]/g, "");
  const countryStr = String(country || "").toLowerCase();
  const isUS =
    cc === "1" ||
    ccRaw === "+1" ||
    countryStr === "united states" ||
    countryStr === "united states of america";
  /* No country context at all → default to US formatting, which reads much
     better than raw digits. Once a country is chosen (e.g. India on Profile) it
     formats per that country instead. */
  if (isUS || (!cc && !countryStr)) return formatUSPhoneNumber(value);
  return formatInternationalPhoneNumber(value, cc);
}

export function getCallingCode(countryName) {
  const c = topCountries.find(
    (x) => x.name.toLowerCase() === String(countryName || "").toLowerCase()
  );
  return c ? c.callingCode : "";
}
